// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25l3C","clinicsSelect":"styles_clinicsSelect__3lVzc"};